import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";

import {
  IncidenciaSeguridadRes,
  IncidenciaSeguridadRevisionMensual,
} from "../../shared/model/iso42001/incidencia-seguridad.model";
import { IncidenciasSeguridadService } from "../incidencias-seguridad.service";

export interface RevisionMensualSeguridadDialogData {
  ventana?: IncidenciaSeguridadRes;
}

@Component({
  selector: "app-revision-mensual-seguridad-dialog",
  standalone: true,
  templateUrl: "./revision-mensual-seguridad-dialog.component.html",
  styleUrls: ["./revision-mensual-seguridad-dialog.component.css"],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
})
export class RevisionMensualSeguridadDialogComponent {
  comentario = "";
  error = "";
  guardando = false;
  revisionActual?: IncidenciaSeguridadRevisionMensual;
  periodo = "";

  constructor(
    private incidenciasService: IncidenciasSeguridadService,
    private dialogRef: MatDialogRef<RevisionMensualSeguridadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RevisionMensualSeguridadDialogData,
  ) {
    const ventana = data?.ventana || {};
    this.revisionActual = ventana.revisionMensual;
    this.periodo = ventana.periodoRevision || "";
    this.comentario = this.revisionActual?.comentario || "";
  }

  get puedeGuardar(): boolean {
    return !this.revisionActual && !!this.comentario.trim() && !this.guardando;
  }

  get periodoCapitalizado(): string {
    return this.capitalizarInicial(this.periodo);
  }

  cerrar(): void {
    this.dialogRef.close({ refresh: false });
  }

  guardar(): void {
    if (!this.comentario.trim()) {
      this.error = "Agrega un comentario para registrar la revisión mensual.";
      return;
    }
    this.guardando = true;
    this.error = "";
    this.incidenciasService.guardarRevisionMensual({ comentario: this.comentario.trim() }).subscribe({
      next: (res) => {
        if (!res || res.codigoError) {
          this.error = res?.mensajeError || "No fue posible guardar la revisión mensual.";
          this.guardando = false;
          return;
        }
        this.revisionActual = res.revisionMensual;
        this.periodo = res.periodoRevision || this.periodo;
        this.guardando = false;
        this.dialogRef.close({ refresh: true });
      },
      error: (e) => {
        this.error = this.mensajeErrorHttp(e, "No fue posible guardar la revisión mensual.");
        this.guardando = false;
      },
    });
  }

  private mensajeErrorHttp(e: any, fallback: string): string {
    if (!e) {
      return fallback;
    }
    if (typeof e === "string") {
      return e;
    }
    if (typeof e?.error === "string") {
      return e.error || fallback;
    }
    const headerMessage = e?.headers?.get?.("IDMESSAGE");
    return e?.error?.mensajeError || e?.error?.message || e?.mensajeError || e?.message || headerMessage || fallback;
  }

  private capitalizarInicial(value?: string): string {
    if (!value) {
      return "";
    }
    const texto = value.trim();
    return texto ? texto.charAt(0).toUpperCase() + texto.slice(1) : "";
  }
}
